"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_modal_1 = __importDefault(require("react-modal"));
const compliance_pool_types_1 = require("../../compliance-pool-types");
const common_styled_components_1 = require("../../../common-styled-components");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../../theme");
const ShipEditor_1 = require("./ShipEditor");
const PoolEditor_1 = require("./PoolEditor");
const CompanyEditor_1 = require("./CompanyEditor");
const TransactionEditor_1 = require("./TransactionEditor");
const FleetEditor_1 = require("./FleetEditor");
const isNullish_1 = require("../../../../util/isNullish");
const UserEditor_1 = require("./UserEditor");
const BalancePlanEditor_1 = require("./BalancePlanEditor");
const CompanyYearlyDataEditor_1 = require("./CompanyYearlyDataEditor");
const lodash_1 = require("lodash");
const TransactionAttachmentFileEditor_1 = require("./TransactionAttachmentFileEditor");
const PortEditor_1 = require("./PortEditor");
const BookingEditor_1 = require("./BookingEditor");
const getModalActionLabel = (modalType) => {
    switch (modalType) {
        case "add":
            return "Add";
        case "edit":
            return "Save";
        case "remove":
            return "Remove";
        default:
            return "undefined action (shouldn't happen)";
    }
};
const Buttons = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: ${theme_1.theme.spacing(3)};
`;
const canSubmit = (type, state) => {
    switch (type) {
        case "company":
            const company = state;
            return !(0, isNullish_1.isNullish)(company.name) && company.name !== "";
        case "ship":
            const ship = state;
            return (0, compliance_pool_types_1.isValidShipInput)(ship);
        case "pool":
            const pool = state;
            return !(0, isNullish_1.isNullish)(pool.name) && pool.name !== "";
        case "port":
            const port = state;
            return (0, compliance_pool_types_1.isValidPortInput)(port);
        case "fleet":
            const fleet = state;
            return (!(0, isNullish_1.isNullish)(fleet.name) &&
                fleet.name !== "" &&
                !(0, isNullish_1.isNullish)(fleet.company_id));
        case "user":
            const user = state;
            return (0, compliance_pool_types_1.isValidUserInput)(user);
        case "transaction":
            const transaction = state;
            return (0, compliance_pool_types_1.isValidTransactionInput)(transaction);
        case "balancePlan":
            const balancePlan = state;
            return (0, compliance_pool_types_1.isValidBalancePlanInput)(balancePlan);
        case "companyYearlyData":
            const companyYearlyData = state;
            return (0, compliance_pool_types_1.isValidCompanyYearlyDataInput)(companyYearlyData);
        case "booking":
            const booking = state;
            return (0, compliance_pool_types_1.isValidBookingInput)(booking);
        default:
            return false;
    }
};
const Modal = ({ isOpen, value, type, modalType, closeModal, submit, onStateChange, pending, pool, companyId, shipId, }) => {
    const [modalState, setModalState] = (0, react_1.useState)(value ?? {});
    (0, react_1.useEffect)(() => {
        if (value && !(0, lodash_1.isEqual)(value, modalState)) {
            setModalState(value);
        }
    }, [value]);
    const updateValue = (key, newValue) => {
        setModalState((prevState) => {
            const next = { ...prevState, [key]: newValue };
            if (onStateChange) {
                onStateChange(next);
            }
            return next;
        });
    };
    const renderEditor = () => {
        if (!modalType) {
            return (0, jsx_runtime_1.jsx)("div", {});
        }
        switch (type) {
            case "company":
                return ((0, jsx_runtime_1.jsx)(CompanyEditor_1.CompanyEditor, { updateValue: updateValue, modalType: modalType, state: modalState }));
            case "ship":
                return ((0, jsx_runtime_1.jsx)(ShipEditor_1.ShipEditor, { updateValue: updateValue, modalType: modalType, state: modalState }));
            case "pool":
                return ((0, jsx_runtime_1.jsx)(PoolEditor_1.PoolEditor, { updateValue: updateValue, modalType: modalType, state: modalState }));
            case "port":
                return ((0, jsx_runtime_1.jsx)(PortEditor_1.PortEditor, { updateValue: updateValue, modalType: modalType, state: modalState }));
            case "fleet":
                return ((0, jsx_runtime_1.jsx)(FleetEditor_1.FleetEditor, { updateValue: updateValue, modalType: modalType, state: modalState }));
            case "transaction":
                return ((0, jsx_runtime_1.jsx)(TransactionEditor_1.TransactionEditor, { updateValue: updateValue, modalType: modalType, state: modalState, pool: pool }));
            case "user":
                return ((0, jsx_runtime_1.jsx)(UserEditor_1.UserEditor, { updateValue: updateValue, modalType: modalType, state: modalState }));
            case "balancePlan":
                return ((0, jsx_runtime_1.jsx)(BalancePlanEditor_1.BalancePlanEditor, { updateValue: updateValue, modalType: modalType, state: modalState, shipId: shipId }));
            case "companyYearlyData":
                return ((0, jsx_runtime_1.jsx)(CompanyYearlyDataEditor_1.CompanyYearlyDataEditor, { updateValue: updateValue, modalType: modalType, state: modalState }));
            case "booking":
                return ((0, jsx_runtime_1.jsx)(BookingEditor_1.BookingEditor, { updateValue: updateValue, modalType: modalType, state: modalState, poolId: pool?.id, companyId: companyId }));
            case "transactionAttachmentFile":
                return (0, jsx_runtime_1.jsx)(TransactionAttachmentFileEditor_1.TransactionAttachmentFileEditor, { modalType: modalType });
            default:
                return null;
        }
    };
    return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, { isOpen: isOpen, style: common_styled_components_1.baseReactModalStyles, onRequestClose: () => closeModal(), shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, children: [renderEditor(), (0, jsx_runtime_1.jsxs)(Buttons, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { onClick: () => closeModal(), disabled: pending === true, children: "Close" }), modalType !== undefined && ((0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: () => {
                            if (pending === true) {
                                return;
                            }
                            if (submit)
                                submit(modalType, modalState);
                        }, disabled: pending === true ||
                            (!!modalType &&
                                modalType !== "remove" &&
                                !canSubmit(type, modalState)), children: getModalActionLabel(modalType) }))] })] }));
};
exports.Modal = Modal;
